import { Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import {
    useParams
} from "react-router-dom";
import { getImg } from '../services';
export default function ImgShow(props) {
    let { imgId } = useParams();
    const [imgSrc, setimgSrc] = useState("")
    const [isLoading, setisLoading] = useState(true)
    useEffect(() => {
        const data = { imgId }
        getImg(data).then(res => {
            if (res.data.responseCode == "200") {
                setisLoading(false)
                setimgSrc(res.data.data.image)
            }
            else setisLoading(false)
        })
    }, [])
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: "100vw", height: "100vh", backgroundImage: 'url("https://st2.depositphotos.com/1012885/10665/i/950/depositphotos_106659592-stock-photo-grey-background-in-grunge-style.jpg")' }}>
            {isLoading ?
                <Skeleton
                    animation="wave"
                    // height={10}
                    width="50%"
                    height="100%"
                />
                :
                <img src={imgSrc} alt="Không tải được ảnh" style={{ maxWidth: "80%", maxHeight: "80%" }} />
            }
        </div>
    )
}

